export default {
  FETCH_APPLICATION: 'fetchApplication',
  FETCH_LOCATION: 'fetchLocation',
  FETCH_ROL: 'fetchRol',
  FETCH_RESULT: 'fetchResult',
  FETCH_MESSAGE_BY_ID: 'fetchMessageById',
  DELETE_MESSAGE: 'deleteMessage',
  SAVE_CHANGES: 'saveMessageChanges',
};
